import { render } from "./VideoThumb.vue?vue&type=template&id=2d398c32"
import script from "./VideoThumb.vue?vue&type=script&lang=ts"
export * from "./VideoThumb.vue?vue&type=script&lang=ts"

import "./VideoThumb.vue?vue&type=style&index=0&id=2d398c32&lang=scss"
script.render = render

export default script